module.exports = __webpack_public_path__ + "static/media/VKFest_1_t.8541ca0d.jpg";